import { IconButton, Popover, Tooltip, useTheme } from '@mui/material';
import { EllipsisVertical } from 'lucide-react';
import { bindPopover, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  title?: string;
  orientation?: 'horizontal' | 'vertical';
  placement?: 'left' | 'right';
  dark?: boolean;
  popoverDark?: boolean;
};

const KebabMenu: React.FC<Props> = ({
  title,
  orientation = 'vertical',
  placement = 'right',
  dark = false,
  popoverDark = false,
  children,
}) => {
  const theme = useTheme();
  const chartBackgrounds = theme.palette.chart?.backgrounds;

  const popupState = usePopupState({ variant: 'popover', popupId: 'kebab' });

  return (
    <>
      <Tooltip title={title}>
        <IconButton {...bindTrigger(popupState)}>
          <EllipsisVertical color={dark ? theme.palette.darkBlue.main : theme.palette.common.white} />
        </IconButton>
      </Tooltip>
      <Popover
        {...bindPopover(popupState)}
        keepMounted
        onClickCapture={() => popupState.close()}
        elevation={15}
        anchorOrigin={{
          vertical: 'center',
          horizontal: placement === 'left' ? 'left' : 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              display: 'flex',
              flexDirection: orientation === 'vertical' ? 'column' : 'row',
              ...(popoverDark
                ? {
                    backgroundColor: chartBackgrounds?.raised ?? theme.palette.background.paper,
                    border: `1px solid ${theme.palette.chart?.borders.subtle ?? theme.palette.divider}`,
                    color: theme.palette.chart?.text.primary ?? theme.palette.text.primary,
                  }
                : {}),
              '& svg': {
                color: popoverDark
                  ? theme.palette.chart?.text.primary ?? theme.palette.text.primary
                  : theme.palette.darkBlue.main,
              },
            },
          },
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: placement === 'left' ? 'right' : 'left',
        }}>
        {children}
      </Popover>
    </>
  );
};

export default KebabMenu;
